export interface NotificationTypeI18n {
  name: string;
  description: string;
  order?: number;
}

export const NOTIFICATION_TYPE_DEFINITIONS: Record<string, NotificationTypeI18n> = {
  'a2p-registration-failure-rollup': {
    name: 'NOTIFICATIONS.TYPES.A2P_REGISTRATION_FAILURE_ROLLUP.NAME',
    description: 'NOTIFICATIONS.TYPES.A2P_REGISTRATION_FAILURE_ROLLUP.DESCRIPTION',
  },
  'abandoned-shopping-cart-notification': {
    name: 'NOTIFICATIONS.TYPES.ABANDONED_SHOPPING_CART_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.ABANDONED_SHOPPING_CART_NOTIFICATION.DESCRIPTION',
  },
  'account-template-applied': {
    name: 'NOTIFICATIONS.TYPES.ACCOUNT_TEMPLATE_APPLIED.NAME',
    description: 'NOTIFICATIONS.TYPES.ACCOUNT_TEMPLATE_APPLIED.DESCRIPTION',
  },
  // demo only — prod uses 'address-validation-errors'
  'address-validation-error': {
    name: 'NOTIFICATIONS.TYPES.ADDRESS_VALIDATION_ERRORS.NAME',
    description: 'NOTIFICATIONS.TYPES.ADDRESS_VALIDATION_ERRORS.DESCRIPTION',
  },
  'address-validation-errors': {
    name: 'NOTIFICATIONS.TYPES.ADDRESS_VALIDATION_ERRORS.NAME',
    description: 'NOTIFICATIONS.TYPES.ADDRESS_VALIDATION_ERRORS.DESCRIPTION',
  },
  'address-validation-suggestion': {
    name: 'NOTIFICATIONS.TYPES.ADDRESS_VALIDATION_SUGGESTION.NAME',
    description: 'NOTIFICATIONS.TYPES.ADDRESS_VALIDATION_SUGGESTION.DESCRIPTION',
  },
  'ai-search-specialist-profile-optimization': {
    name: 'NOTIFICATIONS.TYPES.AI_SEARCH_SPECIALIST_PROFILE_OPTIMIZATION.NAME',
    description: 'NOTIFICATIONS.TYPES.AI_SEARCH_SPECIALIST_PROFILE_OPTIMIZATION.DESCRIPTION',
  },
  'automata-automation-errors': {
    name: 'NOTIFICATIONS.TYPES.AUTOMATA_AUTOMATION_ERRORS.NAME',
    description: 'NOTIFICATIONS.TYPES.AUTOMATA_AUTOMATION_ERRORS.DESCRIPTION',
  },
  'bulk-action-status': {
    name: 'NOTIFICATIONS.TYPES.BULK_ACTION_STATUS.NAME',
    description: 'NOTIFICATIONS.TYPES.BULK_ACTION_STATUS.DESCRIPTION',
  },
  'bulk-actions-export-finished': {
    name: 'NOTIFICATIONS.TYPES.BULK_ACTIONS_EXPORT_FINISHED.NAME',
    description: 'NOTIFICATIONS.TYPES.BULK_ACTIONS_EXPORT_FINISHED.DESCRIPTION',
  },
  'bulk-actions-import-finished': {
    name: 'NOTIFICATIONS.TYPES.BULK_ACTIONS_IMPORT_FINISHED.NAME',
    description: 'NOTIFICATIONS.TYPES.BULK_ACTIONS_IMPORT_FINISHED.DESCRIPTION',
  },
  'bulk-processor-status': {
    name: 'NOTIFICATIONS.TYPES.BULK_PROCESSOR_STATUS.NAME',
    description: 'NOTIFICATIONS.TYPES.BULK_PROCESSOR_STATUS.DESCRIPTION',
  },
  'business-center-activity': {
    name: 'NOTIFICATIONS.TYPES.BUSINESS_CENTER_ACTIVITY.NAME',
    description: 'NOTIFICATIONS.TYPES.BUSINESS_CENTER_ACTIVITY.DESCRIPTION',
  },
  'calendar-event-cancelled': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CANCELLED.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CANCELLED.DESCRIPTION',
  },
  'calendar-event-cancelled-additional-host': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CANCELLED_ADDITIONAL_HOST.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CANCELLED_ADDITIONAL_HOST.DESCRIPTION',
  },
  'calendar-event-created': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CREATED.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CREATED.DESCRIPTION',
  },
  'calendar-event-created-additional-host': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CREATED_ADDITIONAL_HOST.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_CREATED_ADDITIONAL_HOST.DESCRIPTION',
  },
  'calendar-event-reminder': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_REMINDER.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_REMINDER.DESCRIPTION',
  },
  'calendar-event-reminder-additional-host': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_REMINDER_ADDITIONAL_HOST.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_REMINDER_ADDITIONAL_HOST.DESCRIPTION',
  },
  'calendar-event-rescheduled': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_RESCHEDULED.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_RESCHEDULED.DESCRIPTION',
  },
  'calendar-event-rescheduled-additional-host': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_RESCHEDULED_ADDITIONAL_HOST.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_EVENT_RESCHEDULED_ADDITIONAL_HOST.DESCRIPTION',
  },
  'calendar-not-connected': {
    name: 'NOTIFICATIONS.TYPES.CALENDAR_NOT_CONNECTED.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDAR_NOT_CONNECTED.DESCRIPTION',
  },
  'calendly-dupe-account': {
    name: 'NOTIFICATIONS.TYPES.CALENDLY_DUPE_ACCOUNT.NAME',
    description: 'NOTIFICATIONS.TYPES.CALENDLY_DUPE_ACCOUNT.DESCRIPTION',
  },
  'cancellation-request-assignee-notification': {
    name: 'NOTIFICATIONS.TYPES.CANCELLATION_REQUEST_ASSIGNEE_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.CANCELLATION_REQUEST_ASSIGNEE_NOTIFICATION.DESCRIPTION',
  },
  'card-expires-soon': {
    name: 'NOTIFICATIONS.TYPES.CARD_EXPIRES_SOON.NAME',
    description: 'NOTIFICATIONS.TYPES.CARD_EXPIRES_SOON.DESCRIPTION',
  },
  'commerce-bulk-action': {
    name: 'NOTIFICATIONS.TYPES.COMMERCE_BULK_ACTION.NAME',
    description: 'NOTIFICATIONS.TYPES.COMMERCE_BULK_ACTION.DESCRIPTION',
  },
  'connection-broken-notification': {
    name: 'NOTIFICATIONS.TYPES.CONNECTION_BROKEN_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.CONNECTION_BROKEN_NOTIFICATION.DESCRIPTION',
  },
  'connection-completed-notification': {
    name: 'NOTIFICATIONS.TYPES.CONNECTION_COMPLETED_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.CONNECTION_COMPLETED_NOTIFICATION.DESCRIPTION',
  },
  'constant-contact-billing-tier-changed': {
    name: 'NOTIFICATIONS.TYPES.CONSTANT_CONTACT_BILLING_TIER_CHANGED.NAME',
    description: 'NOTIFICATIONS.TYPES.CONSTANT_CONTACT_BILLING_TIER_CHANGED.DESCRIPTION',
  },
  'credit-increment-partner-notification': {
    name: 'NOTIFICATIONS.TYPES.CREDIT_INCREMENT_PARTNER_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.CREDIT_INCREMENT_PARTNER_NOTIFICATION.DESCRIPTION',
  },
  'credit-pool-low-reserve-empty': {
    name: 'NOTIFICATIONS.TYPES.CREDIT_POOL_LOW_RESERVE_EMPTY.NAME',
    description: 'NOTIFICATIONS.TYPES.CREDIT_POOL_LOW_RESERVE_EMPTY.DESCRIPTION',
    order: 4,
  },
  'credit-pool-low-reserve-funded': {
    name: 'NOTIFICATIONS.TYPES.CREDIT_POOL_LOW_RESERVE_FUNDED.NAME',
    description: 'NOTIFICATIONS.TYPES.CREDIT_POOL_LOW_RESERVE_FUNDED.DESCRIPTION',
    order: 1,
  },
  'credit-pool-out-of-credits': {
    name: 'NOTIFICATIONS.TYPES.CREDIT_POOL_OUT_OF_CREDITS.NAME',
    description: 'NOTIFICATIONS.TYPES.CREDIT_POOL_OUT_OF_CREDITS.DESCRIPTION',
    order: 5,
  },
  'credit-pool-used-reserve-funded': {
    name: 'NOTIFICATIONS.TYPES.CREDIT_POOL_USED_RESERVE_FUNDED.NAME',
    description: 'NOTIFICATIONS.TYPES.CREDIT_POOL_USED_RESERVE_FUNDED.DESCRIPTION',
    order: 2,
  },
  'credit-reserve-low': {
    name: 'NOTIFICATIONS.TYPES.CREDIT_RESERVE_LOW.NAME',
    description: 'NOTIFICATIONS.TYPES.CREDIT_RESERVE_LOW.DESCRIPTION',
    order: 3,
  },
  'crm-integrations-new-lead-captured': {
    name: 'NOTIFICATIONS.TYPES.CRM_INTEGRATIONS_NEW_LEAD_CAPTURED.NAME',
    description: 'NOTIFICATIONS.TYPES.CRM_INTEGRATIONS_NEW_LEAD_CAPTURED.DESCRIPTION',
  },
  'dependency-update': {
    name: 'NOTIFICATIONS.TYPES.DEPENDENCY_UPDATE.NAME',
    description: 'NOTIFICATIONS.TYPES.DEPENDENCY_UPDATE.DESCRIPTION',
  },
  'digital-agent-question-asked-notification': {
    name: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_QUESTION_ASKED_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_QUESTION_ASKED_NOTIFICATION.DESCRIPTION',
  },
  'digital-agent-social-post-failed-notification': {
    name: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_SOCIAL_POST_FAILED_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_SOCIAL_POST_FAILED_NOTIFICATION.DESCRIPTION',
  },
  'digital-agent-tagging-event': {
    name: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_TAGGING_EVENT.NAME',
    description: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_TAGGING_EVENT.DESCRIPTION',
  },
  'digital-agent-visible-task-approval-notification': {
    name: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_VISIBLE_TASK_APPROVAL_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_VISIBLE_TASK_APPROVAL_NOTIFICATION.DESCRIPTION',
  },
  'digital-agent-visible-task-feedback-notification': {
    name: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_VISIBLE_TASK_FEEDBACK_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.DIGITAL_AGENT_VISIBLE_TASK_FEEDBACK_NOTIFICATION.DESCRIPTION',
  },
  'email-domain-unverified': {
    name: 'NOTIFICATIONS.TYPES.EMAIL_DOMAIN_UNVERIFIED.NAME',
    description: 'NOTIFICATIONS.TYPES.EMAIL_DOMAIN_UNVERIFIED.DESCRIPTION',
  },
  'executive-report-ready': {
    name: 'NOTIFICATIONS.TYPES.EXECUTIVE_REPORT_READY.NAME',
    description: 'NOTIFICATIONS.TYPES.EXECUTIVE_REPORT_READY.DESCRIPTION',
  },
  'export-failed': {
    name: 'NOTIFICATIONS.TYPES.EXPORT_FAILED.NAME',
    description: 'NOTIFICATIONS.TYPES.EXPORT_FAILED.DESCRIPTION',
  },
  'export-opportunity-pipeline-csv': {
    name: 'NOTIFICATIONS.TYPES.EXPORT_OPPORTUNITY_PIPELINE_CSV.NAME',
    description: 'NOTIFICATIONS.TYPES.EXPORT_OPPORTUNITY_PIPELINE_CSV.DESCRIPTION',
  },
  'export-successful': {
    name: 'NOTIFICATIONS.TYPES.EXPORT_SUCCESSFUL.NAME',
    description: 'NOTIFICATIONS.TYPES.EXPORT_SUCCESSFUL.DESCRIPTION',
  },
  'generic-automation-notification': {
    name: 'NOTIFICATIONS.TYPES.GENERIC_AUTOMATION_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.GENERIC_AUTOMATION_NOTIFICATION.DESCRIPTION',
  },
  'google-my-business-answer': {
    name: 'NOTIFICATIONS.TYPES.GOOGLE_MY_BUSINESS_ANSWER.NAME',
    description: 'NOTIFICATIONS.TYPES.GOOGLE_MY_BUSINESS_ANSWER.DESCRIPTION',
  },
  'google-my-business-question': {
    name: 'NOTIFICATIONS.TYPES.GOOGLE_MY_BUSINESS_QUESTION.NAME',
    description: 'NOTIFICATIONS.TYPES.GOOGLE_MY_BUSINESS_QUESTION.DESCRIPTION',
  },
  'gsuite-setup-failure': {
    name: 'NOTIFICATIONS.TYPES.GSUITE_SETUP_FAILURE.NAME',
    description: 'NOTIFICATIONS.TYPES.GSUITE_SETUP_FAILURE.DESCRIPTION',
  },
  'high-priority-automation-notification': {
    name: 'NOTIFICATIONS.TYPES.HIGH_PRIORITY_AUTOMATION_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.HIGH_PRIORITY_AUTOMATION_NOTIFICATION.DESCRIPTION',
  },
  'hot-lead-notifications': {
    name: 'NOTIFICATIONS.TYPES.HOT_LEAD_NOTIFICATIONS.NAME',
    description: 'NOTIFICATIONS.TYPES.HOT_LEAD_NOTIFICATIONS.DESCRIPTION',
  },
  'import-finished': {
    name: 'NOTIFICATIONS.TYPES.IMPORT_FINISHED.NAME',
    description: 'NOTIFICATIONS.TYPES.IMPORT_FINISHED.DESCRIPTION',
  },
  'inbound-message': {
    name: 'NOTIFICATIONS.TYPES.INBOUND_MESSAGE.NAME',
    description: 'NOTIFICATIONS.TYPES.INBOUND_MESSAGE.DESCRIPTION',
  },
  'inbox-messages': {
    name: 'NOTIFICATIONS.TYPES.INBOX_MESSAGES.NAME',
    description: 'NOTIFICATIONS.TYPES.INBOX_MESSAGES.DESCRIPTION',
  },
  'inbox-new-lead-captured': {
    name: 'NOTIFICATIONS.TYPES.INBOX_NEW_LEAD_CAPTURED.NAME',
    description: 'NOTIFICATIONS.TYPES.INBOX_NEW_LEAD_CAPTURED.DESCRIPTION',
  },
  'inbox-returning-lead-captured': {
    name: 'NOTIFICATIONS.TYPES.INBOX_RETURNING_LEAD_CAPTURED.NAME',
    description: 'NOTIFICATIONS.TYPES.INBOX_RETURNING_LEAD_CAPTURED.DESCRIPTION',
  },
  'invoice-auto-generated': {
    name: 'NOTIFICATIONS.TYPES.INVOICE_AUTO_GENERATED.NAME',
    description: 'NOTIFICATIONS.TYPES.INVOICE_AUTO_GENERATED.DESCRIPTION',
  },
  'invoice-payment-failed': {
    name: 'NOTIFICATIONS.TYPES.INVOICE_PAYMENT_FAILED.NAME',
    description: 'NOTIFICATIONS.TYPES.INVOICE_PAYMENT_FAILED.DESCRIPTION',
  },
  'invoice-processing-failed': {
    name: 'NOTIFICATIONS.TYPES.INVOICE_PROCESSING_FAILED.NAME',
    description: 'NOTIFICATIONS.TYPES.INVOICE_PROCESSING_FAILED.DESCRIPTION',
  },
  'knowledge-source-website-scrape-finished': {
    name: 'NOTIFICATIONS.TYPES.KNOWLEDGE_SOURCE_WEBSITE_SCRAPE_FINISHED.NAME',
    description: 'NOTIFICATIONS.TYPES.KNOWLEDGE_SOURCE_WEBSITE_SCRAPE_FINISHED.DESCRIPTION',
  },
  'meeting-analysis-conversation-analyzed': {
    name: 'NOTIFICATIONS.TYPES.MEETING_ANALYSIS_CONVERSATION_ANALYZED.NAME',
    description: 'NOTIFICATIONS.TYPES.MEETING_ANALYSIS_CONVERSATION_ANALYZED.DESCRIPTION',
  },
  'meeting-starting-soon': {
    name: 'NOTIFICATIONS.TYPES.MEETING_STARTING_SOON.NAME',
    description: 'NOTIFICATIONS.TYPES.MEETING_STARTING_SOON.DESCRIPTION',
  },
  'new-reseller': {
    name: 'NOTIFICATIONS.TYPES.NEW_RESELLER.NAME',
    description: 'NOTIFICATIONS.TYPES.NEW_RESELLER.DESCRIPTION',
  },
  'partner-daily-activity': {
    name: 'NOTIFICATIONS.TYPES.PARTNER_DAILY_ACTIVITY.NAME',
    description: 'NOTIFICATIONS.TYPES.PARTNER_DAILY_ACTIVITY.DESCRIPTION',
  },
  'partner-financial-health': {
    name: 'NOTIFICATIONS.TYPES.PARTNER_FINANCIAL_HEALTH.NAME',
    description: 'NOTIFICATIONS.TYPES.PARTNER_FINANCIAL_HEALTH.DESCRIPTION',
  },
  'partner-task-visibility-waiting-on-customer': {
    name: 'NOTIFICATIONS.TYPES.PARTNER_TASK_VISIBILITY_WAITING_ON_CUSTOMER.NAME',
    description: 'NOTIFICATIONS.TYPES.PARTNER_TASK_VISIBILITY_WAITING_ON_CUSTOMER.DESCRIPTION',
  },
  'partner-visible-project-due-date-changed': {
    name: 'NOTIFICATIONS.TYPES.PARTNER_VISIBLE_PROJECT_DUE_DATE_CHANGED.NAME',
    description: 'NOTIFICATIONS.TYPES.PARTNER_VISIBLE_PROJECT_DUE_DATE_CHANGED.DESCRIPTION',
  },
  'payout-paid': {
    name: 'NOTIFICATIONS.TYPES.PAYOUT_PAID.NAME',
    description: 'NOTIFICATIONS.TYPES.PAYOUT_PAID.DESCRIPTION',
  },
  'pending-domain-spf-record-business-ready-notification': {
    name: 'NOTIFICATIONS.TYPES.PENDING_DOMAIN_SPF_RECORD_BUSINESS_READY_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.PENDING_DOMAIN_SPF_RECORD_BUSINESS_READY_NOTIFICATION.DESCRIPTION',
  },
  'pending-domain-spf-record-partner-ready-notification': {
    name: 'NOTIFICATIONS.TYPES.PENDING_DOMAIN_SPF_RECORD_PARTNER_READY_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.PENDING_DOMAIN_SPF_RECORD_PARTNER_READY_NOTIFICATION.DESCRIPTION',
  },
  'platform-announcement': {
    name: 'NOTIFICATIONS.TYPES.PLATFORM_ANNOUNCEMENT.NAME',
    description: 'NOTIFICATIONS.TYPES.PLATFORM_ANNOUNCEMENT.DESCRIPTION',
  },
  'product-activation-failure': {
    name: 'NOTIFICATIONS.TYPES.PRODUCT_ACTIVATION_FAILURE.NAME',
    description: 'NOTIFICATIONS.TYPES.PRODUCT_ACTIVATION_FAILURE.DESCRIPTION',
  },
  'proposal-awaiting-approval': {
    name: 'NOTIFICATIONS.TYPES.PROPOSAL_AWAITING_APPROVAL.NAME',
    description: 'NOTIFICATIONS.TYPES.PROPOSAL_AWAITING_APPROVAL.DESCRIPTION',
  },
  'proposal-builder-pdf-download-ready': {
    name: 'NOTIFICATIONS.TYPES.PROPOSAL_BUILDER_PDF_DOWNLOAD_READY.NAME',
    description: 'NOTIFICATIONS.TYPES.PROPOSAL_BUILDER_PDF_DOWNLOAD_READY.DESCRIPTION',
  },
  'proposal-comment-received-v2': {
    name: 'NOTIFICATIONS.TYPES.PROPOSAL_COMMENT_RECEIVED_V2.NAME',
    description: 'NOTIFICATIONS.TYPES.PROPOSAL_COMMENT_RECEIVED_V2.DESCRIPTION',
  },
  'proposal-order-approved': {
    name: 'NOTIFICATIONS.TYPES.PROPOSAL_ORDER_APPROVED.NAME',
    description: 'NOTIFICATIONS.TYPES.PROPOSAL_ORDER_APPROVED.DESCRIPTION',
  },
  'proposal-submit-internal-review': {
    name: 'NOTIFICATIONS.TYPES.PROPOSAL_SUBMIT_INTERNAL_REVIEW.NAME',
    description: 'NOTIFICATIONS.TYPES.PROPOSAL_SUBMIT_INTERNAL_REVIEW.DESCRIPTION',
  },
  'proposal-viewed': {
    name: 'NOTIFICATIONS.TYPES.PROPOSAL_VIEWED.NAME',
    description: 'NOTIFICATIONS.TYPES.PROPOSAL_VIEWED.DESCRIPTION',
  },
  // demo only — prod uses 'purchase-failure-v2'
  'purchase-failure': {
    name: 'NOTIFICATIONS.TYPES.PURCHASE_FAILURE.NAME',
    description: 'NOTIFICATIONS.TYPES.PURCHASE_FAILURE.DESCRIPTION',
  },
  'purchase-failure-v2': {
    name: 'NOTIFICATIONS.TYPES.PURCHASE_FAILURE_V2.NAME',
    description: 'NOTIFICATIONS.TYPES.PURCHASE_FAILURE_V2.DESCRIPTION',
  },
  'quickbooks-invoice-paid': {
    name: 'NOTIFICATIONS.TYPES.QUICKBOOKS_INVOICE_PAID.NAME',
    description: 'NOTIFICATIONS.TYPES.QUICKBOOKS_INVOICE_PAID.DESCRIPTION',
  },
  'quote-accepted': {
    name: 'NOTIFICATIONS.TYPES.QUOTE_ACCEPTED.NAME',
    description: 'NOTIFICATIONS.TYPES.QUOTE_ACCEPTED.DESCRIPTION',
  },
  'recommendation-snapshot-ready': {
    name: 'NOTIFICATIONS.TYPES.RECOMMENDATION_SNAPSHOT_READY.NAME',
    description: 'NOTIFICATIONS.TYPES.RECOMMENDATION_SNAPSHOT_READY.DESCRIPTION',
  },
  'retail-disputes': {
    name: 'NOTIFICATIONS.TYPES.RETAIL_DISPUTES.NAME',
    description: 'NOTIFICATIONS.TYPES.RETAIL_DISPUTES.DESCRIPTION',
  },
  'retail-invoice-overdue': {
    name: 'NOTIFICATIONS.TYPES.RETAIL_INVOICE_OVERDUE.NAME',
    description: 'NOTIFICATIONS.TYPES.RETAIL_INVOICE_OVERDUE.DESCRIPTION',
  },
  'retail-payment-partner-notification': {
    name: 'NOTIFICATIONS.TYPES.RETAIL_PAYMENT_PARTNER_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.RETAIL_PAYMENT_PARTNER_NOTIFICATION.DESCRIPTION',
  },
  'retail-payment-smb-merchant-notification': {
    name: 'NOTIFICATIONS.TYPES.RETAIL_PAYMENT_SMB_MERCHANT_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.RETAIL_PAYMENT_SMB_MERCHANT_NOTIFICATION.DESCRIPTION',
  },
  'review-response-update': {
    name: 'NOTIFICATIONS.TYPES.REVIEW_RESPONSE_UPDATE.NAME',
    description: 'NOTIFICATIONS.TYPES.REVIEW_RESPONSE_UPDATE.DESCRIPTION',
  },
  'sales-order-activation-failed': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_ACTIVATION_FAILED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_ACTIVATION_FAILED.DESCRIPTION',
  },
  'sales-order-cancellation-approved': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_CANCELLATION_APPROVED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_CANCELLATION_APPROVED.DESCRIPTION',
  },
  'sales-order-cancellation-declined': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_CANCELLATION_DECLINED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_CANCELLATION_DECLINED.DESCRIPTION',
  },
  'sales-order-cancellation-requested': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_CANCELLATION_REQUESTED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_CANCELLATION_REQUESTED.DESCRIPTION',
  },
  'sales-order-contract-viewed': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_CONTRACT_VIEWED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_CONTRACT_VIEWED.DESCRIPTION',
  },
  'sales-order-created': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_CREATED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_CREATED.DESCRIPTION',
  },
  'sales-order-expiring': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_EXPIRING.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_EXPIRING.DESCRIPTION',
  },
  'sales-order-status-changed': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_STATUS_CHANGED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_STATUS_CHANGED.DESCRIPTION',
  },
  'sales-order-upcoming-trial-conversion-activation': {
    name: 'NOTIFICATIONS.TYPES.SALES_ORDER_UPCOMING_TRIAL_CONVERSION_ACTIVATION.NAME',
    description: 'NOTIFICATIONS.TYPES.SALES_ORDER_UPCOMING_TRIAL_CONVERSION_ACTIVATION.DESCRIPTION',
  },
  'salesperson-cancellation-request': {
    name: 'NOTIFICATIONS.TYPES.SALESPERSON_CANCELLATION_REQUEST.NAME',
    description: 'NOTIFICATIONS.TYPES.SALESPERSON_CANCELLATION_REQUEST.DESCRIPTION',
  },
  'salesperson-task-visibility-waiting-on-customer': {
    name: 'NOTIFICATIONS.TYPES.SALESPERSON_TASK_VISIBILITY_WAITING_ON_CUSTOMER.NAME',
    description: 'NOTIFICATIONS.TYPES.SALESPERSON_TASK_VISIBILITY_WAITING_ON_CUSTOMER.DESCRIPTION',
  },
  'salesperson-visible-project-due-date-changed': {
    name: 'NOTIFICATIONS.TYPES.SALESPERSON_VISIBLE_PROJECT_DUE_DATE_CHANGED.NAME',
    description: 'NOTIFICATIONS.TYPES.SALESPERSON_VISIBLE_PROJECT_DUE_DATE_CHANGED.DESCRIPTION',
  },
  'service-change-request-resolved': {
    name: 'NOTIFICATIONS.TYPES.SERVICE_CHANGE_REQUEST_RESOLVED.NAME',
    description: 'NOTIFICATIONS.TYPES.SERVICE_CHANGE_REQUEST_RESOLVED.DESCRIPTION',
  },
  'session-invitee-deregistered': {
    name: 'NOTIFICATIONS.TYPES.SESSION_INVITEE_DEREGISTERED.NAME',
    description: 'NOTIFICATIONS.TYPES.SESSION_INVITEE_DEREGISTERED.DESCRIPTION',
  },
  'session-invitee-registered': {
    name: 'NOTIFICATIONS.TYPES.SESSION_INVITEE_REGISTERED.NAME',
    description: 'NOTIFICATIONS.TYPES.SESSION_INVITEE_REGISTERED.DESCRIPTION',
  },
  'session-invitee-registration-failed': {
    name: 'NOTIFICATIONS.TYPES.SESSION_INVITEE_REGISTRATION_FAILED.NAME',
    description: 'NOTIFICATIONS.TYPES.SESSION_INVITEE_REGISTRATION_FAILED.DESCRIPTION',
  },
  'rep-review-response-draft': {
    name: 'NOTIFICATIONS.TYPES.REP_REVIEW_RESPONSE_DRAFT.NAME',
    description: 'NOTIFICATIONS.TYPES.REP_REVIEW_RESPONSE_DRAFT.DESCRIPTION',
  },
  'sm-content-creator-draft': {
    name: 'NOTIFICATIONS.TYPES.SM_CONTENT_CREATOR_DRAFT.NAME',
    description: 'NOTIFICATIONS.TYPES.SM_CONTENT_CREATOR_DRAFT.DESCRIPTION',
  },
  'sm-scheduled-post': {
    name: 'NOTIFICATIONS.TYPES.SM_SCHEDULED_POST.NAME',
    description: 'NOTIFICATIONS.TYPES.SM_SCHEDULED_POST.DESCRIPTION',
  },
  'smb-service-cancellation-request': {
    name: 'NOTIFICATIONS.TYPES.SMB_SERVICE_CANCELLATION_REQUEST.NAME',
    description: 'NOTIFICATIONS.TYPES.SMB_SERVICE_CANCELLATION_REQUEST.DESCRIPTION',
  },
  'smb-visible-project-due-date-changed': {
    name: 'NOTIFICATIONS.TYPES.SMB_VISIBLE_PROJECT_DUE_DATE_CHANGED.NAME',
    description: 'NOTIFICATIONS.TYPES.SMB_VISIBLE_PROJECT_DUE_DATE_CHANGED.DESCRIPTION',
  },
  'snapshot-report-ready': {
    name: 'NOTIFICATIONS.TYPES.SNAPSHOT_REPORT_READY.NAME',
    description: 'NOTIFICATIONS.TYPES.SNAPSHOT_REPORT_READY.DESCRIPTION',
  },
  'socialpost-feedback-update': {
    name: 'NOTIFICATIONS.TYPES.SOCIALPOST_FEEDBACK_UPDATE.NAME',
    description: 'NOTIFICATIONS.TYPES.SOCIALPOST_FEEDBACK_UPDATE.DESCRIPTION',
  },
  socialservicebrokentoken: {
    name: 'NOTIFICATIONS.TYPES.SOCIALSERVICEBROKENTOKEN.NAME',
    description: 'NOTIFICATIONS.TYPES.SOCIALSERVICEBROKENTOKEN.DESCRIPTION',
  },
  'subscription-action-notification': {
    name: 'NOTIFICATIONS.TYPES.SUBSCRIPTION_ACTION_NOTIFICATION.NAME',
    description: 'NOTIFICATIONS.TYPES.SUBSCRIPTION_ACTION_NOTIFICATION.DESCRIPTION',
  },
  'task-assignee-updated': {
    name: 'NOTIFICATIONS.TYPES.TASK_ASSIGNEE_UPDATED.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_ASSIGNEE_UPDATED.DESCRIPTION',
  },
  'task-due-soon': {
    name: 'NOTIFICATIONS.TYPES.TASK_DUE_SOON.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_DUE_SOON.DESCRIPTION',
  },
  'task-project-cancellation': {
    name: 'NOTIFICATIONS.TYPES.TASK_PROJECT_CANCELLATION.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_PROJECT_CANCELLATION.DESCRIPTION',
  },
  'task-project-completed-pc-admin': {
    name: 'NOTIFICATIONS.TYPES.TASK_PROJECT_COMPLETED_PC_ADMIN.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_PROJECT_COMPLETED_PC_ADMIN.DESCRIPTION',
  },
  'task-visibility-project-generated-account-salesperson': {
    name: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_PROJECT_GENERATED_ACCOUNT_SALESPERSON.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_PROJECT_GENERATED_ACCOUNT_SALESPERSON.DESCRIPTION',
  },
  'task-visibility-project-generated-order-creator-partner-admin': {
    name: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_PROJECT_GENERATED_ORDER_CREATOR_PARTNER_ADMIN.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_PROJECT_GENERATED_ORDER_CREATOR_PARTNER_ADMIN.DESCRIPTION',
  },
  'task-visibility-project-generated-order-creator-salesperson': {
    name: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_PROJECT_GENERATED_ORDER_CREATOR_SALESPERSON.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_PROJECT_GENERATED_ORDER_CREATOR_SALESPERSON.DESCRIPTION',
  },
  'task-visibility-waiting-on-customer': {
    name: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_WAITING_ON_CUSTOMER.NAME',
    description: 'NOTIFICATIONS.TYPES.TASK_VISIBILITY_WAITING_ON_CUSTOMER.DESCRIPTION',
  },
  'the-loop-comment-activity': {
    name: 'NOTIFICATIONS.TYPES.THE_LOOP_COMMENT_ACTIVITY.NAME',
    description: 'NOTIFICATIONS.TYPES.THE_LOOP_COMMENT_ACTIVITY.DESCRIPTION',
  },
  'ticket-status-changed': {
    name: 'NOTIFICATIONS.TYPES.TICKET_STATUS_CHANGED.NAME',
    description: 'NOTIFICATIONS.TYPES.TICKET_STATUS_CHANGED.DESCRIPTION',
  },
  'unverified-email-domain-final-notice': {
    name: 'NOTIFICATIONS.TYPES.UNVERIFIED_EMAIL_DOMAIN_FINAL_NOTICE.NAME',
    description: 'NOTIFICATIONS.TYPES.UNVERIFIED_EMAIL_DOMAIN_FINAL_NOTICE.DESCRIPTION',
  },
  'work-order-created': {
    name: 'NOTIFICATIONS.TYPES.WORK_ORDER_CREATED.NAME',
    description: 'NOTIFICATIONS.TYPES.WORK_ORDER_CREATED.DESCRIPTION',
  },
  'wsp-uptime-notify': {
    name: 'NOTIFICATIONS.TYPES.WSP_UPTIME_NOTIFY.NAME',
    description: 'NOTIFICATIONS.TYPES.WSP_UPTIME_NOTIFY.DESCRIPTION',
  },
  'wsp-uptime-notifier-3': {
    name: 'NOTIFICATIONS.TYPES.WSP_UPTIME_NOTIFY.NAME',
    description: 'NOTIFICATIONS.TYPES.WSP_UPTIME_NOTIFY.DESCRIPTION',
  },
};

export function notificationTypeOrder(notificationTypeId: string): number {
  return NOTIFICATION_TYPE_DEFINITIONS[notificationTypeId]?.order ?? Number.MAX_SAFE_INTEGER;
}
